<template>
  <div class="locale-changer">
    <v-icon style="margin-right: 5px; color: white;">mdi-earth</v-icon>
    <select v-model="$i18n.locale" class="language-select">
      <option value="de">
         Deutsch
      </option>
      <option value="en">
         Englisch
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'locale-changer',
  data () {
    return { langs: ['de', 'en'] }
  }
}
</script>

<style scoped>
.language-select {
  color: white;
  background-color: transparent;
  border: none;
  outline: none;
  font-weight: 500;
  cursor: pointer;
}

.language-select option {
  color: black;
  background-color: white;
}
</style>
